export const Confirmation = {
  CANCEL_REQUEST: 'Cancel Request',
  CANCEL_REQUEST_CONFIRMATION: 'Are you sure you want to cancel your follow request?',
  CANCEL_AUTO_RENEWAL: 'Cancel Auto-Renewal'
};

export const REMOTE_CONFIG = {
  ADVERTISEMENT: 'Advertisement',
  PAYMENT_CONFIG: 'Payment_Config'
}

export const FollowRequestStatus = {
  THE_FOLLOW_REQUEST_IS_UNDER_REVIEW_BY: 'Your Follow Request is being reviewed by ',
  YOU_ARE_NOW_FOLLOWING: 'You are now following ',
  FOLLOW_PRIVATE_BODY_LEAD: 'Once approved, ',
  FOLLOW_BODY_AFTER_NAMES:
    ' can notify you about new content and other exclusive opportunities. To restrict what information is shared with ',
  FOLLOW_BODY_END:
    ' or which notifications you receive, go to Preferences > Privacy and Notifications.'
}

export const SubscriptionsConstant = {
  Subscription_Required: 'Subscription Required',
  Select: 'Select',
  Learn_More_About_This_Plan: 'Learn More About This Plan',
  only_accepts_Direct_Message_from_Subscribers: 'only accepts Direct Message from Subscribers, please subscribe now.',
  To_unlock_content_please_choose_options_below: 'To unlock this content, please choose one of the subscription plans below:',
}

export const MinTipConstant = {
  SET: 'Set',
  EDIT: 'Edit',
  INDIVIDUAL_PRICE: 'Individual Price',
  AMOUNT: 'Amount',
  TIP: 'Tip',
  TIP_AMOUNT: 'Tip Amount',
  MINIMUM_TIP_AMOUNT: 'Minimum Tip Amount',
  SET_TIP: 'Set Tip',
  UPDATE: 'Update',
  CONTINUE: 'Continue',
  You_cannot_tip_less_than: '*You cannot tip less than $',
}

export const ReportConstant = {
  WE_DONT_ALLOW_SUCH_THINGS: 'We don\'t allow things such as:',
  Thankyou_for_reporting: 'Thank you for reporting this content',
  We_appreciate_your_help: 'We appreciate your help in keeping the TopFan community safe and enjoyable for everyone.',
  IMMEDIATE_DANGER: 'If someone is in immediate danger, get help by contacting local police and medical authorities before reporting to TopFan.',
  CommunityStandards: 'Community Standards',
  ReportAsInappropriate: 'Report as Inappropriate',
  Submit: 'Submit',
  OKAY: 'OKAY',
  Back: 'Back',
}